module.exports = __webpack_public_path__ + "56364bea5a9905430ba676740a48d128.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lankenau02.jpg
// module id = 658
// module chunks = 0